/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { omit } from 'underscore';

import { REQUEST_REFUSAL_CONTRACT_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(REQUEST_REFUSAL_CONTRACT_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((payload) =>
      AjaxRequest.open('post', `/admin/contractcustom/contracts/${payload.contractId}/requestandrefusal`, {
        ...omit(payload, 'contractId'),
      })('tudo')
        // telli pode responder 200 sem corpo — response null não é falha
        .flatMap(({ response }) => Observable.of(success(response ? response.resource : null)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
